// extracted by mini-css-extract-plugin
export default {"becomeRealtorForm":"style_becomeRealtorForm__gTQC5","errorText":"style_errorText__deQoU"};